import script from "./fileImport.vue?vue&type=script&lang=ts&setup=true"
export * from "./fileImport.vue?vue&type=script&lang=ts&setup=true"

import "./fileImport.vue?vue&type=style&index=0&id=9ce07fe0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ce07fe0"]])

export default __exports__